import { type SVGProps, useId } from "react";

export function CampaignsIcon(props: SVGProps<SVGSVGElement>) {
	const titleId = useId();
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			strokeWidth={1.5}
			role="img"
			aria-labelledby={titleId}
			{...props}
		>
			<title id={titleId}>Campaigns</title>
			<path
				d="M10.6667 1.3335V4.00016M2 6.66683H14M5.33333 1.3335V4.00016M11.3333 9.3335H7.33333M8.66667 12.0002H4.66667M4.66667 9.3335H4.67333M11.3333 12.0002H11.34M3.33333 2.66683H12.6667C13.403 2.66683 14 3.26378 14 4.00016V13.3335C14 14.0699 13.403 14.6668 12.6667 14.6668H3.33333C2.59695 14.6668 2 14.0699 2 13.3335V4.00016C2 3.26378 2.59695 2.66683 3.33333 2.66683Z"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}
